import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import type React from "react";
import { useId, useState } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "@/features/auth";

export function UserMenu(): React.ReactElement {
	const navigate = useNavigate();
	const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorElUser);
	const { email, usergroup, handleSignOut } = useAuth();
	const customizedButtonId = useId();
	const menuAppbarId = useId();

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorElUser(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorElUser(null);
	};

	const handleLogout = async () => {
		await handleSignOut();
		handleClose();
		navigate("/login");
	};

	const menuContents = [
		{
			label: "管理者リスト",
			icon: <SupervisorAccountIcon fontSize="small" />,
			action: () => {
				navigate("/admins");
				handleClose();
			},
		},

		{
			label: "ログアウト",
			icon: <LogoutIcon fontSize="small" />,
			action: handleLogout,
		},
	];

	return (
		<Box>
			<Tooltip title="メニュー">
				<Button
					id={customizedButtonId}
					aria-controls={open ? "demo-customized-menu" : undefined}
					aria-haspopup="true"
					aria-expanded={open ? "true" : undefined}
					disableElevation
					onClick={handleOpen}
					endIcon={<KeyboardArrowDownIcon />}
					sx={{ minWidth: "170px", bgcolor: "#ffffff" }}
				>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<Avatar
							sx={{
								width: 30,
								height: 30,
								border: "1px solid #000000",
								backgroundColor: "#ffffff",
							}}
						>
							<PersonIcon sx={{ color: "#000000" }} />
						</Avatar>
						<Box sx={{ textAlign: "left", marginLeft: "8px", lineHeight: 1 }}>
							<Typography fontWeight="bold" sx={{ color: "#000000", fontSize: "11px" }}>
								{email}
							</Typography>
							<Typography sx={{ color: "#666666", fontSize: "8px" }}>{usergroup}</Typography>
						</Box>
					</Box>
				</Button>
			</Tooltip>
			<Menu
				id={menuAppbarId}
				anchorEl={anchorElUser}
				keepMounted
				slotProps={{
					paper: {
						elevation: 0,
						sx: {
							overflow: "visible",
							filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
							mt: 1.5,
							"& .MuiAvatar-root": {
								width: 32,
								height: 32,
								ml: -0.5,
								mr: 1,
							},
							"&:before": {
								content: '""',
								display: "block",
								position: "absolute",
								top: 0,
								right: 14,
								width: 10,
								height: 10,
								bgcolor: "background.paper",
								transform: "translateY(-50%) rotate(45deg)",
								zIndex: 0,
							},
						},
					},
				}}
				transformOrigin={{ horizontal: "right", vertical: "top" }}
				anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
				open={Boolean(anchorElUser)}
				onClose={handleClose}
			>
				<MenuItem sx={{ cursor: "default" }}>
					<Avatar sx={{ bgcolor: "grey" }}>
						<PersonIcon />
					</Avatar>
					<Typography variant="body2">{email}</Typography>
				</MenuItem>
				<Divider />
				{menuContents.map((item) => {
					return (
						<MenuItem key={item.label} onClick={item.action} sx={{ py: 1.5 }}>
							<ListItemIcon>{item.icon}</ListItemIcon>
							<Typography variant="body2" sx={{ textAlign: "center" }}>
								{item.label}
							</Typography>
						</MenuItem>
					);
				})}
			</Menu>
		</Box>
	);
}
